var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Spinner } from "components/authComponents/Spinner";
import { jwtDecode } from "jwt-decode";
import { Navigate } from "react-router-dom";
import api from "shared/api/axios-instance";
import TokenService from "shared/api/token-service";
var isTokenValid = function (token) {
    if (!token)
        return false;
    try {
        var cleanToken = token.replace(/^Bearer\s+/i, "");
        var decoded = jwtDecode(cleanToken);
        var currentTime = Math.floor(Date.now() / 1000);
        return decoded.exp > currentTime;
    }
    catch (_a) {
        return false;
    }
};
export var ProtectedRoute = function (_a) {
    var children = _a.children;
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState(false), authorized = _c[0], setAuthorized = _c[1];
    useEffect(function () {
        var checkTokens = function () { return __awaiter(void 0, void 0, void 0, function () {
            var accessToken, res, newAccessToken, err_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        accessToken = TokenService.getAccessToken();
                        if (isTokenValid(accessToken)) {
                            setAuthorized(true);
                            setLoading(false);
                            return [2 /*return*/];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, api.get("/auth/refresh-tokens")];
                    case 2:
                        res = _b.sent();
                        newAccessToken = (_a = res.data) === null || _a === void 0 ? void 0 : _a.accessToken;
                        if (newAccessToken) {
                            TokenService.setAccessToken(newAccessToken);
                            setAuthorized(true);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _b.sent();
                        console.error("❌ Ошибка при обновлении токена:", err_1);
                        setAuthorized(false);
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        checkTokens();
    }, []);
    if (loading)
        return _jsx(Spinner, {});
    if (!authorized)
        return _jsx(Navigate, { to: "/auth", replace: true });
    return children;
};
